import React, { useContext } from 'react'
import { dataAttrTestId } from '@at/formatter-utils/lib/data-attr-utils/data-attr-utils'
import { IconSavedOff, IconSavedOn } from '@at/design-system-icons'
import { NewStyledSaveAdvertButton } from './action-save-button.styles'
import { useATTrackInteraction } from '@at/consumer-web-snowplow'
import { SignInEntityContext } from '@at/connected-signin'

interface AdvertSaveIconProps {
    disabled?: boolean
    loading?: boolean
    onClick: () => void
    saved: boolean
    testId?: string
}

export const SaveAdvertButton = ({
    saved,
    onClick,
    loading,
    disabled = false,
    testId = 'save-advert-button',
}: AdvertSaveIconProps) => {
    const handleTrackingInteraction = useATTrackInteraction({
        trackingLabel: `save-vehicle${saved ? '-remove' : ''}`,
    })
    const signInEntityContext = useContext(SignInEntityContext)

    const handleButtonClick = () => {
        signInEntityContext.onTrigger()
        handleTrackingInteraction({
            customiseEntities: (entities) =>
                signInEntityContext.contextEntity ? [...entities, signInEntityContext.contextEntity] : entities,
        })
        onClick()
    }

    const SaveIcon = saved ? IconSavedOn : IconSavedOff

    return (
        <NewStyledSaveAdvertButton
            onClick={handleButtonClick}
            save={saved}
            disabled={loading || disabled}
            {...{ [dataAttrTestId]: testId }}
        >
            <SaveIcon title="Save advert" customSize={{ width: 18, height: 18 }} viewBox="2 2 20 20" />
        </NewStyledSaveAdvertButton>
    )
}
